module.exports = __webpack_public_path__ + "static/media/30.36d12b5d.png";